import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Ic } from './Icons';
import { useTheme } from './ThemeContext';

export const NAV = [
  { id: "accueil",   label: "Accueil",    icon: "home",  n: "01", path: "/" },
  { id: "factures",  label: "Factures",   icon: "euro",  n: "02", path: "/invoices" },
  { id: "devis",     label: "Devis",      icon: "doc",   n: "03", path: "/quotes" },
  { id: "clients",   label: "Clients",    icon: "user",  n: "04", path: "/clients" },
  { id: "charges",   label: "Charges",    icon: "chart", n: "05", path: "/charges" },
  { id: "trimestres",label: "Trimestres", icon: "cal",   n: "06", path: "/trimestres" },
  { id: "pluie",     label: "Pluie",      icon: "rain",  n: "07", path: "/rain" },
  { id: "automower", label: "Automower",  icon: "mow",   n: "08", path: "/automower" },
  { id: "hue",       label: "HUE",        icon: "bulb",  n: "09", path: "/hue" },
  { id: "admin",     label: "Admin",      icon: "cog",   n: "10", path: "/admin/netatmo" },
  { id: "chatgpt",   label: "ChatGPT",    icon: "chat",  n: "11", path: "/chat" },
];

export default function Rail({ onLogout }) {
  const location = useLocation();
  const { theme, toggleTheme } = useTheme();

  const isActive = (path) => {
    if (path === '/') return location.pathname === '/';
    if (path === '/admin/netatmo') return location.pathname.startsWith('/admin');
    return location.pathname.startsWith(path);
  };

  return (
    <aside className="ta-rail" aria-label="Navigation principale">
      <Link to="/" className="ta-rail-logo" aria-label="Accueil">
        <img src="/logoMS.png" alt="MS" />
        <span className="ta-rail-logo-dot" />
        <span className="ta-rail-logo-name">MATTHIEU·SIMAR</span>
      </Link>
      <nav className="ta-rail-nav">
        {NAV.map((item) => {
          const active = isActive(item.path);
          return (
            <Link
              key={item.id}
              to={item.path}
              className={`ta-rail-item ${active ? "is-active" : ""}`}
              aria-label={item.label}
              aria-current={active ? "page" : undefined}
            >
              <span className="ta-rail-n">{item.n}</span>
              <span className="ta-rail-ic" aria-hidden="true">{Ic[item.icon]}</span>
              <span className="ta-rail-l">{item.label}</span>
            </Link>
          );
        })}
      </nav>
      <div className="ta-rail-foot">
        <button
          onClick={toggleTheme}
          title={theme === 'dark' ? 'Passer en clair' : 'Passer en sombre'}
          aria-label="Basculer le thème"
        >
          <span />
          <span className="ta-rail-ic">{theme === 'dark' ? Ic.sun : Ic.moon}</span>
          <span className="ta-rail-l">{theme === 'dark' ? 'Mode clair' : 'Mode sombre'}</span>
        </button>
        <button onClick={onLogout} title="Déconnexion" aria-label="Déconnexion">
          <span />
          <span className="ta-rail-ic">{Ic.logout}</span>
          <span className="ta-rail-l">Déconnexion</span>
        </button>
      </div>
    </aside>
  );
}
